import { render } from "./editTeam.vue?vue&type=template&id=6e144c60&scoped=true"
import script from "./editTeam.vue?vue&type=script&lang=js"
export * from "./editTeam.vue?vue&type=script&lang=js"

import "./editTeam.vue?vue&type=style&index=0&id=6e144c60&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e144c60"]])

export default __exports__